const LOCAL_HOSTS = ["localhost", "127.0.0.1", "0.0.0.0", "::1"]

export const isLocalHost = () => {
  if (typeof window === "undefined") return false
  return LOCAL_HOSTS.includes(window.location.hostname)
}

export const isV2LocalAuth = () => {
  if (typeof window === "undefined") return false
  const isV2Auth = process.env.REACT_APP_USE_V2_AUTH === "true"
  if (!isV2Auth) return false
  const keyPrefix = window.localStorage.getItem("keyprefix")
  return keyPrefix === "v2local"
}

export const isLocalNoAwsMode = () => {
  if (!isLocalHost()) return false
  const requiresV2Local = process.env.REACT_APP_USE_V2_AUTH === "true"
  return requiresV2Local ? isV2LocalAuth() : true
}
